import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { getSubjectLines } from 'sections/design/template-management/sections/template-list/utils/queries';

export const useSubjectLinesQuery = (siteId: string) => {
  const { t } = useTranslation('campaigns');

  const subjectLinesQuery = useQuery(['subjectLines', siteId], async () => {
    const result = await getSubjectLines({ siteId, t });
    return result;
  });

  return subjectLinesQuery;
};
